class Auth {
    static canReport = a => (a?.roles || []).indexOf('REPORT') > -1
}

export default Auth;